import Select, { MultiValue } from "react-select";
import styled from "styled-components";

export type MessageTypeSelectProps = {
  value: string | null;
  onChange: (e: { target: { value: string } }) => void;
  autoFocus?: boolean;
};

const MESSAGE_TYPE_OPTIONS = [
  {
    value: "ContentMessage",
    label: "ContentMessage",
  },
  {
    value: "FnCallMessage",
    label: "FnCallMessage",
  },
  {
    value: "KVDelTreeMessage",
    label: "KVDelTreeMessage",
  },
  {
    value: "KVMessage",
    label: "KVMessage",
  },
  {
    value: "PuppeteerMessage",
    label: "PuppeteerMessage",
  },
  {
    value: "ContentEventMessage",
    label: "ContentEventMessage (legacy)",
  },
  {
    value: "FactEventMessage",
    label: "FactEventMessage (legacy)",
  },
  {
    value: "FnCallEventMessage",
    label: "FnCallEventMessage (legacy)",
  },
];

const SelectContainer = styled.div`
  width: 400px;
`;

const MessageTypeSelect = ({
  value,
  onChange,
  autoFocus,
}: MessageTypeSelectProps) => {
  return (
    <SelectContainer>
      <Select
        value={value && JSON.parse(value)}
        isMulti={true}
        options={MESSAGE_TYPE_OPTIONS}
        autoFocus={autoFocus}
        onChange={(value: MultiValue<{ value: string }>) => {
          onChange({
            target: { value: value.length > 0 ? JSON.stringify(value) : "" },
          });
        }}
      />
    </SelectContainer>
  );
};

export default MessageTypeSelect;
